module.exports = __webpack_public_path__ + "static/media/Reiri_Logo.d22e9165.png";